<template>
  <div class="my-20 overflow-x-auto flex">
    <div class="fb-post w-[350px]!" :data-href="postLink" data-width="350" data-show-text="true"></div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'SingleSocialMediaPost - Facebook',
  props: {
    postLink: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.addFacebookScript();
  },
  methods: {
    addFacebookScript() {
      if (!document.querySelector('[data-post="facebook"]')) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://connect.facebook.net/en_EN/sdk.js#xfbml=1&version=v12.0');
        script.setAttribute('async', '');
        script.setAttribute('defer', '');
        script.setAttribute('crossorigin', 'anonymous');
        script.setAttribute('nonce', 'b9MRsF8C');
        script.setAttribute('data-post', 'facebook');
        document.head.appendChild(script);
      }
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
@media screen and (max-width: 370px) {
  .fb-post {
    @apply transform scale-75;
  }
}
@media screen and (min-width: 350px) {
  .fb-post {
    @apply mx-auto;
  }
}
</style>
